export default "__VITE_ASSET__CX9_p896__"